import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'pipeSeparateDate'
})
export class PipeSeparateDate implements PipeTransform {
    constructor() {}

    transform(event) {
        if(event){
            if(moment(event.start).toDate() < moment().toDate() && moment(event.end).toDate() > moment().toDate()){
                return 'event-danger shadow';
            } else if(moment(event.start).toDate() > moment().toDate() && moment(event.start).toDate() <= moment().add(15, 'minutes').toDate()){
                return 'event-warning shadow';
            } else {
                return 'event-light shadow';
            }
        }else {
            return 'event-light shadow';
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeSeparateDate.ts